import styled from '@emotion/styled';

export const Root = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.light.text.primary};
`;
